module.exports = __webpack_public_path__ + "static/media/destination-main.1a03c8ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/destinations/destination-main.jpg
// module id = 189
// module chunks = 0